import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { useBalanceTransferRolloverContext } from '../../../../../../Context';

export default function useResetButton() {
  const { displayErrorMessage, displaySuccess } = useSnackbarContext();
  const {
    balanceTransferResource,
    refreshBalTranCollection,
  } = useBalanceTransferRolloverContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const [confirmShowing, setShowConfirm] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleClick = async () => {
    setLoading(true);
    try {
      logStandardizedEvent(categories.whatIf, eventTypes.clickButton, 'reset balance transfers');
      await balanceTransferResource.relationship(fr.relationships.reset.name).link('related').post();
      await refreshBalTranCollection();
      displaySuccess('Reset successful. Updating scenario.');
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
    setShowConfirm(false);
    setLoading(false);
    refreshPageContentCollection();
  };

  return {
    showConfirm: confirmShowing,
    onCancel: () => setShowConfirm(false),
    onConfirm: handleClick,
    onClick: () => setShowConfirm(true),
    isResetting: loading,
  };
}
